// src/pages/customers/Customers.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import CustomersTable from "../../components/customers/CustomersTable";

const Customers = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <CustomersTable />
        </WrapperSection>
    );
};

export default Customers;
